<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5 23.0001C18.299 23.0001 23 18.2991 23 12.5001C23 6.70113 18.299 2.00012 12.5 2.00012C6.70101 2.00012 2 6.70113 2 12.5001C2 18.2991 6.70101 23.0001 12.5 23.0001ZM11.5 6.00012V12.5001V12.9503L11.837 13.2488L16.4194 17.3069L17.7454 15.8096L13.5 12.0499V6.00012H11.5Z"
      fill="#999999"
    />
  </svg>
</template>

<style scoped lang="postcss"></style>
